import { useNavigate, NavLink } from "react-router";
import { NotificationCategoryAliases } from "@src/constants/constants.js";
import { useAuthContext } from "@src/context";
import OperatorHooks from "@src/context/hooks/operatorHooks";
import Icon from "./Icon";

const NotificationBadge = ({ className = "", isActive = false }) => {
  const navigateTo = useNavigate();
  const auth = useAuthContext();

  const iconName = isActive ? "bellFilled" : "bellOutline";

  const {
    data: { notifications } = {},
    isPending: notificationsPending,
    error: notificationsError,
  } = OperatorHooks.useOperatorNotifications(
    auth?.user?.username,
    auth.activeRole,
    NotificationCategoryAliases["ALL"],
    0,
    10,
  );

  const showUnreadDot = notifications?.some((n) => !n.isRead);

  return (
    <div
      className={`cursor-pointer rounded-full
        transition duration-150 ease-in-out
        flex-shrink-0
        ${className || ""}
      `}
      title="Notifications"
      aria-label="Notifications"
      onClick={() =>
        navigateTo(`/dashboard/${auth.activeRoleRoutePrefix}/notifications`)
      }
    >
      <div className="relative w-6 h-6" role="img">
        <Icon
          size="lg"
          textColor="currentColor"
          name={iconName}
          padding={false}
          className="absolute"
        />
        {showUnreadDot && (
          <span className="w-[10px] h-[10px] absolute top-1 right-px bg-error rounded-full" />
        )}
      </div>
    </div>
  );
};

export default NotificationBadge;
